import { render, staticRenderFns } from "./wuAmend.vue?vue&type=template&id=e104d944&"
import script from "./wuAmend.vue?vue&type=script&lang=js&"
export * from "./wuAmend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports